<template>
  <v-row
    justify="end"
    class="mr-0">
    <v-dialog
      dark
      persistent
      v-model="addItemDialog"
      max-width="600px">
      <v-card>
        <v-card-title class="secondary">
          <span
            class="headline">
            {{ dataForModal ? $t(translation + '.edit') : $t(translation + '.add') }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                large
                icon
                v-bind="attrs"
                v-on="on"
                @click="closeDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <span>
              {{ $t('tooltips.close') }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form
              ref="form"
              v-on:submit.prevent>
              <!--Broj odluke-->
              <v-row>
                <v-col
                  cols="12">
                  <v-text-field
                    v-model="form.number"
                    :label="$t(translation+'.number')+'*'" required
                    :rules="rules.required"
                    autocomplete="off"
                  />
                </v-col>
              </v-row>
              <!--Registar-->
              <v-row>
                <!--Naziv registra-->
                <v-col
                  cols="10">
                  <v-text-field
                    v-model="form.cb_help_category.name"
                    :disabled="isEmptyObject(form.cb_help_category)"
                    :label="$t(translation+'.help_category') + '*'"
                    :rules="rules.required"
                    readonly
                    required
                  />
                </v-col>
                <!--Odaberite registar-->
                <v-col
                  cols="2">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="info mb-2"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        @click="openDialogCbHelpCategoryChooseItem()"
                      >
                        <v-icon>mdi-archive-arrow-up</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      {{ $t('tooltips.open_choose_dialog') }}
                    </span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <!--Tip deminimis pomoci-->
              <v-row
              v-if="form.cb_help_category_id === 2"
              >
                <!--Naziv tipa deminimis pomoci-->
                <v-col
                  cols="10">
                  <v-text-field
                    v-model="form.cb_provider_decision_deminimis_type.name"
                    :disabled="isEmptyObject(form.cb_provider_decision_deminimis_type)"
                    :label="$t(translation+'.cb_provider_decision_deminimis_type') + '*'"
                    :rules="rules.required"
                    readonly
                    required
                  />
                </v-col>
                <!--Odabir tipa deminimis pomoci-->
                <v-col
                  cols="2">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="info mb-2"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        @click="openDialogCbProviderDecisionDeminimisTypeChooseItem()"
                      >
                        <v-icon>mdi-archive-arrow-up</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      {{ $t('tooltips.open_choose_dialog') }}
                    </span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <!--Davaoc pomoci-->
              <v-row>
                <!--Naziv davaoca pomoci-->
                <v-col
                  cols="10">
                  <v-text-field
                    v-model="form.cb_help_provider.name"
                    :disabled="isEmptyObject(form.cb_help_provider)"
                    :label="$t(translation+'.help_provider') + '*'"
                    :rules="rules.required"
                    readonly
                    required
                  />
                </v-col>
                <!--Odabir davaoca pomoci-->
                <v-col
                  v-if="!cbHelpProvider"
                  cols="2">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="info mb-2"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        @click="openDialogCbHelpProviderChooseItem()"
                      >
                        <v-icon>mdi-archive-arrow-up</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      {{ $t('tooltips.open_choose_dialog') }}
                    </span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small>{{ $t('required_fields') }}</small>
        </v-card-text>
        <v-card-actions>
          <div
            class="flex-grow-1">
          </div>
          <v-btn
            class="info mr-2"
            dark
            :loading="loading"
            @click="dataForModal ? edit(apiEdit,form) : add(apiAdd)"
          >
            {{ dataForModal ? $t('edit') : $t('add') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!---------------------------------- Choose cb_help_category item Dialog  ----------------------------------------->
    <dialog-choose-item
      :max-with-prop="600"
      :dialogChooseItem="cbHelpCategoryChooseDialog.showDialog"
      :singleSelect="cbHelpCategoryChooseDialog.singleSelect"
      :id="null"
      :translation="cbHelpCategoryChooseDialog.translation"
      :api="cbHelpCategoryChooseDialog.apiRead"
      :show-columns="cbHelpCategoryChooseDialog.showColumns"
      :headers="generalChooseItemHeaders"
      @closeChooseItemDialog="cbHelpCategoryChooseDialog.showDialog=false"
      @itemChosenEvent="onItemCbHelpCategoryChosenEvent"
    />
    <!---------------------------------- Choose cb_help_category item Dialog  ----------------------------------------->
    <dialog-choose-item
      :max-with-prop="600"
      :dialogChooseItem="cbProviderDecisionDeminimisTypeChooseDialog.showDialog"
      :singleSelect="cbProviderDecisionDeminimisTypeChooseDialog.singleSelect"
      :id="null"
      :translation="cbProviderDecisionDeminimisTypeChooseDialog.translation"
      :api="cbProviderDecisionDeminimisTypeChooseDialog.apiRead"
      :show-columns="cbProviderDecisionDeminimisTypeChooseDialog.showColumns"
      :headers="generalChooseItemHeaders"
      @closeChooseItemDialog="cbProviderDecisionDeminimisTypeChooseDialog.showDialog=false"
      @itemChosenEvent="onItemCbProviderDecisionDeminimisTypeChosenEvent"
    />
    <!---------------------------------- Choose cb_help_provider item Dialog  ----------------------------------------->
    <dialog-choose-item
      :max-with-prop="600"
      :dialogChooseItem="cbHelpProviderChooseDialog.showDialog"
      :singleSelect="cbHelpProviderChooseDialog.singleSelect"
      :id="null"
      :translation="cbHelpProviderChooseDialog.translation"
      :api="cbHelpProviderChooseDialog.apiRead"
      :show-columns="cbHelpProviderChooseDialog.showColumns"
      :headers="generalChooseItemHeaders"
      @closeChooseItemDialog="cbHelpProviderChooseDialog.showDialog=false"
      @itemChosenEvent="onItemCbHelpProviderChosenEvent"
    />
    <!---------------------------------- Snackbar  ----------------------------------------->
    <v-snackbar
      v-model="snackbar.show"
      :bottom=true
      :color="snackbar.color"
      :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <v-btn dark text @click="snackbar.show = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-row>
</template>

<script>
import {add, edit, isEmptyObject} from "../../../statics/DataTableFunctions";
import ChooseItemDialog from "../../user/ChooseItemDialog";

export default {
  props: {
    addItemDialog: false,
    dataForModal: null,
  },
  components: {
    'dialog-choose-item': ChooseItemDialog
  },
  name: "AddCbProviderDecision",
  data() {
    return {
      translation: 'cb.provider_decisions',
      apiAdd: '/api/cb_provider_decisions/store',
      apiEdit: '/api/cb_provider_decisions/update',
      loading: false,
      dateMenu: false,
      cbHelpProvider: localStorage.getItem('cb_help_provider') === 'null' ? null : localStorage.getItem('cb_help_provider'),
      form: {
        number: '',
        cb_help_category: {},
        cb_help_category_id: null,
        cb_provider_decision_deminimis_type: {},
        cb_provider_decision_deminimis_type_id: null,
        cb_help_provider: localStorage.getItem('cb_help_provider') !== 'null' ? JSON.parse(localStorage.getItem('cb_help_provider')) : {},
        cb_help_provider_id: localStorage.getItem('cb_help_provider') !== 'null' ? JSON.parse(localStorage.getItem('cb_help_provider')).id : null,
      },
      rules: {
        required: [
          v => !!v || this.$t('validation.field')
        ],
        required_length: [
          v => !!v || this.$t('validation.field'),
          v => v === '' || v.length > 1 || this.$t(this.translation + '.validation')
        ],
      },
      cbHelpProviderChooseDialog: {
        showDialog: false,
        singleSelect: true,
        translation: 'cb.help_providers',
        apiRead: '/api/cb_help_providers/index',
        showColumns: [
          "id",
          "name"
        ],
      },
      cbProviderDecisionDeminimisTypeChooseDialog: {
        showDialog: false,
        singleSelect: true,
        translation: 'cb.provider_decision_deminimis_type',
        apiRead: '/api/cb_provider_decisions_deminimis_types/index',
        showColumns: [
          "id",
          "name",
          "limit"
        ],
      },
      cbHelpCategoryChooseDialog: {
        showDialog: false,
        singleSelect: true,
        translation: 'cb.help_category',
        apiRead: '/api/cb_help_categories/index',
        showColumns: [
          "id",
          "name"
        ],
      },
      snackbar: {
        color: 'success',
        show: false,
        text: '',
        timeout: 3000,
      },
    }
  },
  methods: {
    add,
    edit,
    isEmptyObject,
    openDialogCbHelpCategoryChooseItem() {
      this.cbHelpCategoryChooseDialog.showDialog = true;
    },
    openDialogCbProviderDecisionDeminimisTypeChooseItem() {
      this.cbProviderDecisionDeminimisTypeChooseDialog.showDialog = true;
    },
    openDialogCbHelpProviderChooseItem() {
      this.cbHelpProviderChooseDialog.showDialog = true;
    },
    onItemCbHelpCategoryChosenEvent(item) {
      this.form.cb_help_category = item;
      this.form.cb_help_category_id = item.id;
      this.cbHelpCategoryChooseDialog.showDialog = false;
    },
    onItemCbProviderDecisionDeminimisTypeChosenEvent(item) {
      this.form.cb_provider_decision_deminimis_type = item;
      this.form.cb_provider_decision_deminimis_type_id = item.id;
      this.cbProviderDecisionDeminimisTypeChooseDialog.showDialog = false;
    },
    onItemCbHelpProviderChosenEvent(item) {
      this.form.cb_help_provider = item;
      this.form.cb_help_provider_id = item.id;
      this.cbHelpProviderChooseDialog.showDialog = false;
    },

    closeDialog() {
      this.isPartner = false;
      this.form = {
        number: '',
        cb_help_category: {},
        cb_help_category_id: null,
        cb_provider_decision_deminimis_type: {},
        cb_provider_decision_deminimis_type_id: null,
        cb_help_provider: localStorage.getItem('cb_help_provider') !== 'null' ? JSON.parse(localStorage.getItem('cb_help_provider')) : {},
        cb_help_provider_id: localStorage.getItem('cb_help_provider') !== 'null' ? JSON.parse(localStorage.getItem('cb_help_provider')).id : null,
      }
      this.$refs.form.resetValidation()
      this.$emit('close')
    },
  },
  computed: {
    generalChooseItemHeaders() {
      return [
        {
          text: this.$t('general.select'),
          name: 'actions',
          align: 'center',
          value: 'actions',
          width: '10px',
          sortable: false
        },
        {
          text: this.$t(this.cbHelpProviderChooseDialog.translation + '.name'),
          name: 'name',
          align: 'left',
          value: 'name'
        },
      ]
    },
  },
  watch: {
    dataForModal: function (val) {
      if (val) {
        this.form = {
          id: this.dataForModal.id,
          number: this.dataForModal.number,
          cb_help_category: this.dataForModal.cb_help_category ? this.dataForModal.cb_help_category : {},
          cb_help_category_id: this.dataForModal.cb_help_category ? this.dataForModal.cb_help_category.id : null,
          cb_provider_decision_deminimis_type: this.dataForModal.cb_provider_decision_deminimis_type ? this.dataForModal.cb_provider_decision_deminimis_type : {},
          cb_provider_decision_deminimis_type_id: this.dataForModal.cb_provider_decision_deminimis_type ? this.dataForModal.cb_provider_decision_deminimis_type.id : null,
          cb_help_provider: this.dataForModal.cb_help_provider,
          cb_help_provider_id: this.dataForModal.cb_help_provider ? this.dataForModal.cb_help_provider.id : null
        }
      }
    },
    'form.cb_help_category_id': function (val) {
      if(val !== 2) {
        this.form.cb_provider_decision_deminimis_type = {};
        this.form.cb_provider_decision_deminimis_type_id = null;
      }
    }
  }
}
</script>

<style scoped/>
